import {ErroneousServerResult, HttpClient, POST, expectEither} from '@raison/network-facade';
import {AccountId, TransactionIdIoTs} from '@raison/types';
import {type} from 'io-ts';
import {CryptoCurrencyType} from '~/entities/currencies';
import {BlockchainInfo, TransactionHolder, signCryptoTransaction} from '~/entities/operations-crypto';

export async function submitConfirmSellTxRequest(
    http: HttpClient,
    data: {
        holder: TransactionHolder;
        wallet: {
            id: AccountId;
            type: CryptoCurrencyType;
            blockchain: BlockchainInfo;
        };
        codeFromSms: string;
    }
) {
    const cypherResult = await signCryptoTransaction(http, data);
    if (cypherResult.status !== 'Ok') {
        return cypherResult;
    }
    const signature = cypherResult.datum;

    const walletId = data.wallet.id;
    const url = (() => {
        switch (data.wallet.type) {
            case 'crypto':
                return `v1/wallets/${walletId}/sell`;
            case 'stablecoin':
                return `v1/tokens/${walletId}/sell`;
        }
    })();

    const response = await http(url, POST(signature)).then(
        ...expectEither({
            200: type({id: TransactionIdIoTs}),
            201: type({id: TransactionIdIoTs}),
            400: ErroneousServerResult,
        })
    );
    if (response.status === 400) {
        return {status: 'BadRequest', datum: response.json.message} as const;
    }
    if (response.status === 'Abort') {
        throw response.reason;
    }

    return {status: 'Ok', datum: {id: response.json.id}} as const;
}
